import { Check, Copy } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../app/store";
import { getCaseCreationState } from "../../cases/logic/CaseCreationSlice";
import ButtonV2 from "../../../components/ui/button/v2";
import { useEffect, useState } from "react";

interface CaseCreateSuccessProps {
    reset: () => void;
}

const REDIRECT_TIMEOUT = 10; // seconds

const CaseCreateSuccess: React.FC<CaseCreateSuccessProps> = (props) => {
    const navigate = useNavigate();
    const caseCreationState = useAppSelector(getCaseCreationState)
    const [timer, setTimer] = useState(REDIRECT_TIMEOUT);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (timer === 0) {
            navigate('/cases');
            return;
        }
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => clearInterval(countdown);
    }, [timer, navigate]);

    return (
        <div className="max-w-3xl mx-auto mt-[64px] flex flex-col items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-formCard w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                <div className="p-6 text-center">
                    <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                        <Check strokeWidth={4} className="lucide lucide-check h-10 w-10 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold mb-2">Case Created Successfully!</h3>
                    <p className="text-gray-600 mb-6">Your new case has been created with the following ID, save this ID for future reference</p>
                    <div className="bg-blue-50 p-6 rounded-md mb-6 border-2 border-slate-100">
                        <p className="text-2xl font-mono font-semibold text-foreground">
                            {caseCreationState.uin || "NORTH-20250704-0LAAO"}
                            <ButtonV2
                                variant="ghost"
                                title={copied ? "Copied!" : "Copy to Clipboard"}
                                prefix={(
                                    !copied ? 
                                        <Copy className="h-4 w-4 ml-2 text-blue-600" />
                                        :
                                        <Check className="h-4 w-4 ml-2 text-green-600" />
                                )}
                                onClick={() => {
                                    navigator.clipboard.writeText(caseCreationState.uin || "NORTH-20250704-0LAAO");
                                    setCopied(true);
                                    setTimeout(() => setCopied(false), 2000);
                                }}
                            />
                        </p>
                    </div>
                    <div className="flex justify-center space-x-4">
                        <ButtonV2
                            variant={"primary"}
                            className="w-full rounded-lg font-medium"
                            textClassName="font-medium"
                            onClick={() => navigate(`/cases/${caseCreationState.caseId}`)}
                        >
                            View Case Details
                        </ButtonV2>
                        <ButtonV2
                            variant={"outline-primary"}
                            className="w-full rounded-lg bg-[#EBEEFE]"
                            textClassName="font-medium"
                            onClick={props.reset}
                        >
                            Create Another Case
                        </ButtonV2>
                    </div>
                </div>
            </div>
            {/* Redirecting to home in 10 seconds... */}
            <div className="mt-4 text-xs font-medium text-gray-500">
                Redirecting to home in {timer} seconds....
            </div>
        </div>
    );
}

export default CaseCreateSuccess;